import { ILogger, LoggerType } from './types';
import AppDynamicsLogger from './AppDynamicsLogger';
import ConsoleLogger from './ConsoleLogger';
import MultiTransportLogger from './MultiTransportLogger';

const buildAppLogger = (
  type?: LoggerType,
  config?: { key: string }
): ILogger => {
  const appLogger = new MultiTransportLogger();

  if (type === 'appDynamics') {
    const appDynamicsLogger = new AppDynamicsLogger(config?.key || '');
    appLogger.register(appDynamicsLogger);
  } else {
    appLogger.register(new ConsoleLogger());
  }

  return appLogger;
};

export default buildAppLogger;
